const orderSettings = {
  orderIdType: "external",
  receiptType: "email",
};

export default orderSettings;
